var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "success icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1105 8.31879V9.05987C17.1095 10.7969 16.5471 12.4871 15.507 13.8784C14.4669 15.2697 13.005 16.2874 11.3392 16.78C9.67345 17.2725 7.8931 17.2133 6.26369 16.6113C4.63428 16.0094 3.24311 14.8968 2.29767 13.4396C1.35223 11.9824 0.903169 10.2585 1.01746 8.52526C1.13175 6.79197 1.80328 5.14206 2.93188 3.82159C4.06048 2.50113 5.58569 1.58087 7.28004 1.19805C8.97438 0.815239 10.7471 0.990383 12.3338 1.69736",
    stroke: "#48B16E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.1125 2.61523L9.0572 10.6786L6.64062 8.26197",
    stroke: "#48B16E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.d3444d87439aac229de2701c4f634353.svg";
export { ForwardRef as ReactComponent };